/* Motion layer for .bw-desc product descriptions.
   Hooks (data attributes in the description HTML):
     data-bw-split        word-by-word masked headline reveal
     data-bw-in           fade/rise (cards: curtain clip) on scroll-in; data-bw-delay="ms" staggers
     data-bw-count="N"    count-up number
     data-bw-steps        scroll-linked timeline (fills line, lights steps)
     data-bw-marquee      infinite marquee (track contents are duplicated here)
   Without JS, or with prefers-reduced-motion, content is shown as plain static markup. */
(function () {
  var roots = document.querySelectorAll('.bw-desc');
  if (!roots.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  Array.prototype.forEach.call(roots, function (root) {
    if (root.classList.contains('bw-ready')) return;
    root.classList.add('bw-ready');
    if (reduced || !hasIO) { root.classList.add('bw-static'); return; }
    root.classList.add('bw-js');
    split(root);
    reveal(root);
    counts(root);
    steps(root);
    marquee(root);
    spotlight(root);
  });

  function onView(els, cb, opts) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Elements already scrolled past (deep-link / reload mid-page) count as seen.
        if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
        cb(e.target);
        io.unobserve(e.target);
      });
    }, opts || { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function split(root) {
    root.querySelectorAll('[data-bw-split]').forEach(function (el) {
      var text = el.textContent.trim().replace(/\s+/g, ' ');
      el.setAttribute('aria-label', text);
      el.innerHTML = text.split(' ').map(function (w, i) {
        return '<span class="bw-w" aria-hidden="true"><span style="--i:' + i + '">' + w + '</span></span>';
      }).join(' ');
    });
  }

  function reveal(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-bw-in],[data-bw-split]'));
    els.forEach(function (el) {
      var d = el.getAttribute('data-bw-delay');
      if (d) el.style.setProperty('--d', d + 'ms');
    });
    onView(els, function (el) {
      el.classList.add('is-in');
      var d = parseFloat(el.getAttribute('data-bw-delay')) || 0;
      // Hand cards back to their hover transitions once the curtain has finished.
      setTimeout(function () { el.classList.add('is-done'); }, 1400 + d);
    });
  }

  function counts(root) {
    var els = root.querySelectorAll('[data-bw-count]');
    els.forEach(function (el) { el.textContent = '0'; });
    onView(Array.prototype.slice.call(els), function (el) {
      var target = parseFloat(el.getAttribute('data-bw-count')) || 0;
      var delay = parseFloat(el.closest('[data-bw-delay]') && el.closest('[data-bw-delay]').getAttribute('data-bw-delay')) || 0;
      var start = null, dur = 1800;
      function tick(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
        el.textContent = Math.round(target * eased).toLocaleString('en-US');
        if (p < 1) requestAnimationFrame(tick);
      }
      setTimeout(function () { requestAnimationFrame(tick); }, delay);
    }, { threshold: 0.6 });
  }

  function steps(root) {
    var wrap = root.querySelector('[data-bw-steps]');
    if (!wrap) return;
    var list = wrap.querySelector('.bw-steps__list');
    var items = Array.prototype.slice.call(wrap.querySelectorAll('.bw-step'));
    if (!list || !items.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight, line = vh * 0.62;
      var rect = list.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var p = Math.min(1, Math.max(0, (line - rect.top) / rect.height));
      list.style.setProperty('--bw-p', p.toFixed(4));
      items.forEach(function (it) {
        it.classList.toggle('is-passed', it.getBoundingClientRect().top < line);
      });
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  function marquee(root) {
    root.querySelectorAll('[data-bw-marquee]').forEach(function (el) {
      var track = el.querySelector('.bw-marquee__track');
      if (!track) return;
      Array.prototype.slice.call(track.children).forEach(function (n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });
    });
  }

  function spotlight(root) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    root.querySelectorAll('.bw-card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }
})();
